import React from "react";
import Filters from "./Filters";
import Donut from "../../../../components/donut/donut";
import Table from "../../../../components/coreUiTable/Table";
import { cuFormat } from "../../../../components/coreUiTable/Format";
import { useDispatch, useSelector } from "react-redux";
import { FETCH_DATA } from "../common/saga";
import PropTypes from "prop-types";
import NoItems from "../../../../components/coreUiTable/NoItems";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import ErrorBoundary from "../../../../components/errorBoundary/errorBoundary";

const Charts = (props) => {
  const dispatch = useDispatch();
  const {
    startDate,
    endDate,
    filtersDirtySt,
    fetchInitialData,
    isLoading,
    moduleName,
    notifications
  } = props;
  const { dataPoints, pieChart, table, filtersDirty, staffFiltersLoading } = useSelector(
    (state) => state[moduleName]
  );

  function renderUpdateBtn() {
    // TODO: remove this part if not used
    if (
      filtersDirty &
      !isLoading &
      (startDate !== "Invalid date") &
      (endDate !== "Invalid date") &
      !staffFiltersLoading
    ) {
      return (
        <button
          className="submit"
          onClick={() => dispatch({ type: FETCH_DATA + moduleName, chartType: moduleName })}
        >
          Update
        </button>
      );
    }

    return null;
  }

  function renderResetBtn() {
    if (filtersDirty & !isLoading & !staffFiltersLoading) {
      return (
        <button className="submit reset" onClick={() => fetchInitialData()}>
          Reset
        </button>
      );
    }
    return null;
  }

  let footerSlot = () => {
    return (
      <tfoot>
        <tr>
          {["TOTAL", ...(table?.totals || [])].map((totalRow, index) => {
            return <td key={index}>{totalRow}</td>;
          })}
        </tr>
      </tfoot>
    );
  };

  return (
    <ErrorBoundary moduleName={moduleName} {...notifications}>
      <SectionToggle
        {...props.sectionProps}
        content={
          <>
            <div
              className="edit-selections-bar ip-header"
              id="sticky-select-bar"
              style={{ zIndex: 1 }}
            >
              <div className="pie-chart-label-container" style={{ width: "25%" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <h4 className="pie-chart-label">{pieChart.label}</h4>
                </div>
              </div>
              <div className="selection-bar-filters" style={{ width: "75%", marginLeft: "1rem" }}>
                <Filters filtersDirtySt={filtersDirtySt} moduleName={props.moduleName} />
              </div>
              {renderUpdateBtn() || renderResetBtn() ? (
                <div className="action-buttons">
                  {renderUpdateBtn()}
                  {renderResetBtn()}
                </div>
              ) : null}
            </div>
            <div className="content-wrapper ip-wrapper">
              {isLoading ? (
                <LoadingAnimation />
              ) : (
                <>
                  <div
                    style={{
                      width: "25%",
                      marginBottom: "3rem",
                      display: "grid",
                      justifyContent: "center"
                    }}
                  >
                    {dataPoints.length > 0 ? (
                      <div>
                        {dataPoints.map(({ label, value, change, raw_data_link }, index) => (
                          <div key={index} className="data-display-container">
                            <DataDisplay
                              label={label}
                              value={value}
                              type={change !== undefined ? "percentage" : "number"}
                              url={raw_data_link}
                              changeProps={{ changeValue: change, showBorder: true }}
                              disableAnimation
                            />
                          </div>
                        ))}
                      </div>
                    ) : (
                      pieChart?.display && (
                        <Donut value={pieChart.value ?? 0} growth={pieChart.change ?? 0} />
                      )
                    )}
                  </div>
                  <div style={{ width: "75%", marginLeft: "1rem" }}>
                    <Table
                      footerSlot={
                        table.data.length > 0 && table?.totals !== undefined && footerSlot()
                      }
                      noItemsViewSlot={<NoItems text={"No data"} />}
                      tableWrapperId="instructorPerformance"
                      itemsPerPage={10}
                      tableFilter={false}
                      sorter={true}
                      table={table}
                      showCount={true}
                      scopedSlots={cuFormat({
                        countTitle: "#",
                        headers: table.colHeaders,
                        columns: table.columns,
                        links: table.links
                      })}
                    />
                  </div>
                </>
              )}
            </div>
          </>
        }
      />
    </ErrorBoundary>
  );
};

export default Charts;

Charts.propTypes = {
  filtersDirtySt: PropTypes.bool,
  isLoading: PropTypes.bool,
  currentUser: PropTypes.object,
  learnMore: PropTypes.objectOf(PropTypes.string),
  filtersDirty: PropTypes.bool,
  fetchInitialData: PropTypes.func,
  updateChart: PropTypes.func,
  moduleName: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  mainTableDataLoading: PropTypes.bool,
  staffFiltersLoading: PropTypes.bool,
  numberOfMonths: PropTypes.number,
  yearOverYearLoading: PropTypes.bool,
  updatesLoading: PropTypes.bool,
  currentSelectedCategory: PropTypes.string,
  sectionProps: PropTypes.object,
  notifications: PropTypes.object
};
